import React from "react";
import PageHero from "../components/PageHero";
import ConsultationCTASection from "../components/ConsultationCTASection";
import { Bell, BookOpen, FileText } from "lucide-react";
import { useConsultation } from "../context/ConsultationContext";

const TEASERS = [
  {
    icon: BookOpen,
    title: "The Mainland vs Freezone Playbook",
    copy: "A 15-minute framework to pick the right structure for your business model.",
  },
  {
    icon: FileText,
    title: "UAE Corporate Tax 2025: what changed",
    copy: "Qualifying income, free-zone benefits, and the 9% threshold — explained.",
  },
  {
    icon: Bell,
    title: "Golden Visa eligibility criteria",
    copy: "Investor, entrepreneur and specialised talent routes, side-by-side.",
  },
];

export default function ResourcesPage() {
  const { open } = useConsultation();

  return (
    <div data-testid="resources-page">
      <PageHero
        eyebrow="Resource Center"
        title="Founders' library —"
        highlight="launching soon."
        copy="We're publishing UAE incorporation guides, tax briefings and immigration checklists written by our senior advisors. Subscribe below to be notified first."
      />

      <section className="bg-white py-20 md:py-28">
        <div className="container-x">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm border border-[#3366FF]/50 bg-[#EEF2FF] text-[#1B3BB8] text-xs font-heading font-bold tracking-widest uppercase">
            Coming soon
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
            {TEASERS.map(({ icon: Icon, title, copy }, i) => (
              <div
                key={title}
                data-testid={`resource-teaser-${i}`}
                className="rounded-sm border border-slate-200 p-8 bg-white hover:shadow-xl hover:border-[#3366FF]/40 transition-all group"
              >
                <Icon className="w-8 h-8 text-[#3366FF]" strokeWidth={1.5} />
                <h3 className="mt-6 font-heading font-semibold text-lg tracking-tight text-[#0F172A]">
                  {title}
                </h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{copy}</p>
                <div className="mt-8 h-px w-10 bg-[#3366FF] group-hover:w-20 transition-all" />
              </div>
            ))}
          </div>

          <div className="mt-14 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="resources-cta"
              onClick={() => open("other")}
              className="btn-navy"
            >
              Request a briefing from a senior advisor
            </button>
          </div>
        </div>
      </section>

      <ConsultationCTASection
        eyebrow="Questions can't wait?"
        title="Skip the wait. Book a 20-minute advisory call today."
      />
    </div>
  );
}
